import { useSelector } from 'react-redux';

const useIDToTitle = (type) => {
	const chosenObject = useSelector((state) => state.globalProgramVariables[type]);
	return chosenObject?.title;
};

export default useIDToTitle;
